import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Sparkles } from "lucide-react";
import NavbarDesktop from "@/components/site/NavbarDesktop";
import NavbarMobile from "@/components/site/NavbarMobile";
import { useAuth } from "@/context/AuthContext";

const BASE_LINKS = [
  { to: "/", label: "Home" },
  { to: "/apply", label: "Apply Now" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/faq", label: "FAQ" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();
  const { user } = useAuth();

  const authLink = user
    ? { to: user.role === "admin" ? "/admin/applications" : "/dashboard", label: user.role === "admin" ? "Admin" : "Dashboard" }
    : { to: "/login", label: "Login" };
  const LINKS = [...BASE_LINKS, authLink];

  return (
    <header data-testid="site-navbar" className="sticky top-0 z-50 bg-[#FCFAF8]/85 backdrop-blur-xl border-b border-[#E8DFD8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <img
            src="https://customer-assets.emergentagent.com/job_agent-funding-pro/artifacts/arvd4npc_image.jpeg"
            alt="Hannah Howard Funding logo"
            className="w-9 h-9 rounded-md object-cover"
          />
          <span className="font-serif-lux text-2xl leading-none">
            Hannah Howard <span className="text-[#8C7A70]">Funding</span>
          </span>
        </Link>

        <NavbarDesktop links={LINKS} />

        <div className="flex items-center gap-3">
          <button
            data-testid="nav-cta-get-funded"
            onClick={() => nav("/apply")}
            className="hidden lg:!inline-flex btn-primary text-sm py-3 px-6"
          >
            Get Funded Today
          </button>
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 rounded-full hover:bg-[#F4EEE8]"
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <NavbarMobile
          links={LINKS}
          onClose={() => setOpen(false)}
          onCta={() => { setOpen(false); nav("/apply"); }}
        />
      )}
    </header>
  );
}
